import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import { get, split } from "lodash";
import Grid from "@material-ui/core/Grid";
import Dialog from "@material-ui/core/Dialog";

import CloseIcon from "./CloseIcon";
import DateFilter from "../Common/DateFilter";
import Loader from "../Common/Loader";
import CustomButton from "./CustomButton";
import { exportTableToCsv, exportTrainToCsv } from "../../utils/data";
import colors from "../../assets/style/colors";
import DownloadIcon from "./DownloadIcon";

const styles = {
  dialogPaper: {
    padding: "12px",
    minWidth: "400px",
    maxWidth: "400px",
  },
  closeIconItem: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  link: {
    cursor: "pointer",
    color: colors.primary,
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const CsvExportDialog = (props) => {
  const {
    classes,
    title,
    columns,
    fetchData,
    dataFunctions,
    maxPeriod,
    headers,
    section,
    railcarData,
    trainYardEventType,
    trainComments,
    trainId,
  } = props;
  const [open, setOpen] = React.useState(false);

  const initialFilter = () => {
    if (maxPeriod) {
      const now = new Date();
      const midnight = new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        0,
        0,
        0
      );
      const startDate = midnight.getTime();
      const endDate = midnight.getTime() + 86400000;
      return {
        dateFilter: "0",
        startDate,
        endDate,
      };
    }
    return {
      dateFilter: "allTime",
    };
  };

  const [filters, setFilters] = React.useState(initialFilter());
  const [isExporting, setIsExporting] = React.useState(false);
  const [overRange, setOverRange] = React.useState();

  // Check over range
  React.useEffect(() => {
    if (maxPeriod && get(filters, ["startDate"]) && get(filters, ["endDate"])) {
      const maxP = split(maxPeriod, /(\d+)/);
      const periodNb = get(maxP, [1]);
      const periodType = get(maxP, [2]);
      const range =
        periodNb *
        (periodType === "d"
          ? 86400
          : periodType === "w"
            ? 604800
            : periodType === "h"
              ? 3600
              : 0) *
        1000;
      if (get(filters, ["endDate"]) - get(filters, ["startDate"]) > range) {
        setOverRange(
          `${I18n.get("site_dateOverRange")} ${periodNb} ${I18n.get(
            periodType === "d"
              ? "dashboard_days"
              : periodType === "w"
                ? "dashboard_weeks"
                : "dashboard_hours"
          )}`
        );
      } else {
        setOverRange();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const exportCsv = async () => {
    if (!section) {
      try {
        setIsExporting(true);
        let data = await fetchData(filters);
        exportTableToCsv(
          title,
          columns,
          data,
          dataFunctions,
          I18n.get,
          {
            from: get(filters, ["startDate"]),
            to: get(filters, ["endDate"]),
          },
          headers
        );
        setOpen(false);
      } catch (e) {
        console.log(e);
      }

    } else {

      try {
        setIsExporting(true);
        exportTrainToCsv(
          title,
          columns,
          railcarData,
          trainId,
          trainYardEventType,
          trainComments
        );
        setOpen(false);
      } catch (e) {
        console.log(e);
      }

    }
    setIsExporting(false);
  };

  return (
    <>
      <DownloadIcon exportCsv={() => setOpen(true)} style={props.style} />
      <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
        <Grid container direction="column">
          <Grid item>
            <Grid container alignItems="center">
              <Grid item xs={2} />
              <Grid item xs className="dialogTitle">
                {I18n.get("dashboard_exportCSV")}
              </Grid>
              <Grid item xs={2} className={classes.closeIconItem}>
                <CloseIcon closeFunction={() => setOpen(false)} />
              </Grid>
            </Grid>
          </Grid>
          {isExporting ? (
            <Grid item className="flexCenter" style={{ height: "244px" }}>
              <Loader noDecoration message={I18n.get("common_exporting")} />
            </Grid>
          ) : (
            <>
              {
                !section ?
                  <Grid item style={{ marginTop: "24px" }}>
                    <DateFilter
                      filters={filters}
                      setFilters={setFilters}
                      columns
                      maxPeriod={maxPeriod}
                      overRange={overRange}
                    />
                  </Grid> :
                  null
              }
              <Grid item className="text-center" style={{ margin: "24px 0px" }}>
                <div style={{ marginBottom: "16px", fontWeight: "500" }}>{trainId} - Event Group: {title}</div>
                <CustomButton
                  variant="contained"
                  color="primary"
                  onClick={exportCsv}
                  disabled={
                    Boolean(overRange) ||
                    (maxPeriod &&
                      (!get(filters, ["startDate"]) ||
                        !get(filters, ["endDate"])))
                  }
                >
                  {I18n.get("dashboard_exportCSV")}
                </CustomButton>
              </Grid>
            </>
          )}
        </Grid>
      </Dialog>
    </>
  );
};

export default withStyles(styles)(CsvExportDialog);
